export default __webpack_public_path__ + "static/media/Close_Button.a2edb51f.svg";